(() => {
  if (customElements.get('yloma-free-shipping')) return;
  class YlomaFreeShipping extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-cart-progress')) return;
      this.listeners?.abort();
      this.listeners = new AbortController();
      this.message = this.querySelector('[data-shipping-message]');
      this.progress = this.querySelector('[data-shipping-progress]');
      this.update({ total_price: Number(this.dataset.total), currency: this.dataset.currency });
      document.addEventListener('cart:change', event => {
        if (event.detail?.cart) this.update(event.detail.cart);
      }, { signal: this.listeners.signal });
    }
    disconnectedCallback() {
      this.listeners?.abort();
    }
    update(cart) {
      if (!this.message) return;
      if (cart.requires_shipping !== undefined) this.hidden = !cart.requires_shipping;
      const threshold = Number(this.dataset.threshold);
      const total = cart.total_price;
      const currency = cart.currency || this.dataset.currency;
      this.dataset.currency = currency;
      const canCalculate = currency === 'EUR' && threshold > 0 && Number.isFinite(total) && total >= 0;
      if (this.progress) this.progress.hidden = !canCalculate;
      if (!canCalculate) {
        this.message.textContent = this.dataset.static;
        return;
      }
      this.dataset.total = String(total);
      if (this.progress) this.progress.value = Math.min(threshold, Math.max(0, total));
      const remaining = new Intl.NumberFormat(this.dataset.locale || 'en', {
        style: 'currency', currency: 'EUR'
      }).format(Math.max(0, threshold - total) / 100);
      this.message.textContent = total >= threshold
        ? this.dataset.reached
        : this.dataset.remaining.replace('[amount]', remaining);
    }
  }
  customElements.define('yloma-free-shipping', YlomaFreeShipping);
})();
